import React from "react";

export const InputError = ({ children, absolute = false, className = "" }: {children: any; absolute?: Boolean; className: string}) => {
  return <p className={`text-red-500 font-bold text-sm ${className} ${absolute && `absolute`}`}>{children}</p>;
};
